<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="resetSchedule">
    <v-card flat>
      <template v-if="finished">
        <v-container>
          <v-row dense>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-img :src="$images.CONGRATS"></v-img>
            </v-col>
            <v-col>
              <h1 class="accent--text mb-2">Congratulations!</h1>
              <div class="secondarytext--text">
                Your resource has successfully been scheduled for
                {{ schedule.sendDate | dateWithDowNoTz }}.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-else>
        <v-card-title>
          Send resource
          <v-spacer></v-spacer>
          <v-btn icon @click="resetSchedule">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          Tell us when you'd like this resource to be sent
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-menu
                    v-model="senddate_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedSendDate"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[$rules.required]"
                      >
                        <template v-slot:label>
                          <v-icon>date_range</v-icon>
                          Send Date
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="schedule.sendDate"
                      @input="senddate_menu = false"
                      :min="minDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="time_menu"
                    v-model="time_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedSendTime"
                        label="Select a time of day"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[$rules.required]"
                      >
                        <template v-slot:label>
                          <v-icon>query_builder</v-icon>
                          Time of Day
                        </template>
                      </v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time_menu"
                      v-model="schedule.sendTime"
                      ampm-in-title
                      :allowed-minutes="allowedStep"
                    >
                    </v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    hide-details
                    v-model="schedule.description"
                    outlined
                    label="Additional message (optional)"
                    :rows="5"
                  >
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-row dense class="subtitle-1 my-auto">
                    <v-col cols="auto">
                      <v-icon small color="accent">person</v-icon>
                      Send Resource To
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="my-auto">
                      <v-checkbox
                        v-model="allMembers"
                        dense
                        hide-details
                        @change="membersAndTeams = []"
                      >
                        <template v-slot:label>
                          <span class="subtitle-1">All Members</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <member-team-autocomplete
                    v-model="membersAndTeams"
                    v-on:change="updateAllMembers"
                    ref="autocomplete"
                  >
                  </member-team-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="saving" @click="save">
            <v-icon>date_range</v-icon>
            {{ scheduleExists ? "Update" : "Schedule" }}
          </v-btn>
          <v-btn :loading="saving" @click="sendNow" v-if="!scheduleExists">
            <v-icon>send</v-icon>
            Send Now
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import MemberTeamAutocomplete from "@/components/members/MemberTeamAutocomplete";
export default {
  name: "ResourceScheduleDialog",
  components: {
    "member-team-autocomplete": MemberTeamAutocomplete
  },
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    senddate_menu: false,
    time_menu: false,
    membersAndTeams: [],
    allMembers: true,
    finished: false,
    resourceId: ""
  }),
  watch: {},
  computed: {
    formattedSendDate() {
      return this.schedule.sendDate
        ? moment(this.schedule.sendDate).format("MM/DD/YYYY")
        : "";
    },
    formattedSendTime() {
      return this.schedule.sendTime
        ? moment(this.schedule.sendTime, "HH:mm:ss").format("hh:mm A")
        : "";
    },
    minDate() {
      return moment().format("YYYY-MM-DD");
    },
    scheduleExists() {
      return this.schedule.id != null;
    },
    ...mapGetters({
      schedule: "resource/schedule"
    })
  },
  methods: {
    allowedStep: m => m % 15 === 0,
    resetSchedule() {
      this.dialog = false;
    },
    updateAllMembers() {
      this.allMembers = this.membersAndTeams.length == 0;
    },
    showDialog(resourceId, instanceId) {
      this.dialog = true;
      this.finished = false;
      this.resourceId = resourceId;

      this.$store
        .dispatch("resource/getResourceSchedule", {
          resourceId,
          id: instanceId
        })
        .then(() => {
          this.membersAndTeams = [];
          this.id = instanceId;
          this.allMembers = this.schedule.allMembers;
          if (!this.schedule.allMembers) {
            this.$store.dispatch("user/clearSearchUsers");
            this.membersAndTeams = (this.schedule.teams || [])
              .map(team => ({
                id: "team|" + team.id,
                name: team.name
              }))
              .concat(
                (this.schedule.users || []).map(member => ({
                  id: "user|" + member.id,
                  name: member.fullName,
                  avatarUrl: member.avatarUrl
                }))
              );
          }
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading this resource schedule."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.schedule.sendTimezone = moment.tz.guess(true);
      this.saving = true;
      this.$store
        .dispatch(
          "resource/saveResourceSchedule",
          this._.merge(this.schedule, this.parseRecipients(), {
            resourceId: this.resourceId
          })
        )
        .then(() => {
          this.$emit("save");

          this.finished = true;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while scheduling a resource."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },
    sendNow() {
      this.schedule.sendTimezone = moment.tz.guess(true);
      this.schedule.sendDate = moment().format("YYYY-MM-DD");
      this.schedule.sendTime = moment().format("HH:mm:ss");
      this.save();
    },
    parseRecipients() {
      let members = this.membersAndTeams
        .filter(x => {
          return (x.id ? x.id : x).indexOf("user|") == 0;
        })
        .map(x => ({ id: (x.id ? x.id : x).replace("user|", "") }));
      let teams = this.membersAndTeams
        .filter(x => (x.id ? x.id : x).indexOf("team|") == 0)
        .map(x => ({ id: (x.id ? x.id : x).replace("team|", "") }));
      return {
        users: members,
        teams: teams,
        allMembers: this.allMembers
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.v-input--checkbox {
  margin-top: 0;
}

.v-input--checkbox >>> .v-label {
  font-size: 12px !important;
}

.v-input--checkbox >>> .v-input__control {
  font-size: 100px !important;
}
</style>
